import { LOCAL, ROOT_FLAG } from "@/store/mutations";
import covergePartial from "./coverage.store-partial";

const { SET_PLAN_ADDONS, SET_PLAN_OWNERSHIP } = LOCAL;

export default {
	namespaced: true,
	state: {
		id: null,
		title: "",
		premium: 0,
		owned: false,
		addons: [],
		coverage_percent: 1,
		coverages: {},
	},
	getters: {
		totalCost: (state) => state.addons.reduce((total, addon) => total + addon.cost, state.premium),
		addon: (state) => (id) => state.addons.find((addon) => addon.id === id),
		hasAddon: (state) => (id) => typeof state.addons.find((addon) => addon.id === id) === "object",
		addonMessage: (state, getters, rootState) => (id) => (getters.hasAddon(id)
			? rootState.global.api.data.addons[id].messages.owned
			: rootState.global.api.data.addons[id].messages.not_owned),
	},
	actions: {
		activate({ dispatch, state }) {
			// eslint-disable-next-line camelcase
			const { owned, type, coverage_percent } = state;
			if (owned) {
				Object.values(state.coverages).forEach((coverage) => {
					const modulePath = ["game", "plans", type, `${coverage.id}`];
					this.registerModule(modulePath, covergePartial);
					dispatch(`${modulePath.join("/")}/create`, { ...coverage, coverage_percent }, ROOT_FLAG);
				});
			}
		},
		purchase({ dispatch, getters }) {
			dispatch("game/balance/withdraw", { amount: getters.totalCost }, ROOT_FLAG);
			dispatch("acquire");
		},
		refund({ dispatch, getters }) {
			dispatch("game/balance/deposit", { amount: getters.totalCost }, ROOT_FLAG);
			dispatch("remove");
		},
		setAddons({ commit }, addons) {
			commit(SET_PLAN_ADDONS, addons);
		},
		acquire({ commit }) {
			commit(SET_PLAN_OWNERSHIP, { owned: true });
		},
		remove({ commit }) {
			commit(SET_PLAN_OWNERSHIP, { owned: false });
		},
	},
	mutations: {
		[SET_PLAN_OWNERSHIP](state, plan) {
			state.owned = plan.owned;
		},
		[SET_PLAN_ADDONS](state, addons) {
			state.addons = addons;
		},
	},
};
